import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { TableHead } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Button } from "@totalsoft/rocket-ui";
import { StyledHeaderCell, StyledTableRow } from 'components/common/Styles';

const FinancialProductRulesEditDetailsIncomesTableHead = ({ canWrite, onAdd, isSaved }) => {
  const { t } = useTranslation();

  return (
    <TableHead>
      <StyledTableRow>
        <StyledHeaderCell>{t("FinancialProduct.Details.Rules.Details.Incomes.ReadOnly")}</StyledHeaderCell>
        <StyledHeaderCell>{t("FinancialProduct.Details.Rules.Details.Incomes.IncomeType")}</StyledHeaderCell>
        <StyledHeaderCell>{t("FinancialProduct.Details.Rules.Details.Incomes.IncomeValue")}</StyledHeaderCell>
        <StyledHeaderCell>{t("FinancialProduct.Details.Rules.Details.Incomes.Currency")}</StyledHeaderCell>
        <StyledHeaderCell>{t("FinancialProduct.Details.Rules.Details.Incomes.Default")}</StyledHeaderCell>
        <StyledHeaderCell>{t("FinancialProduct.Details.Rules.Details.Incomes.Mandatory")}</StyledHeaderCell>
        <StyledHeaderCell align="right">
          <Button color="primary" variant="contained" startIcon={<AddIcon />} disabled={!isSaved || !canWrite} onClick={onAdd}>
            {t("Add")}
          </Button>
        </StyledHeaderCell>
      </StyledTableRow>
    </TableHead>
  );
};

FinancialProductRulesEditDetailsIncomesTableHead.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  isSaved: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired
};

export default FinancialProductRulesEditDetailsIncomesTableHead;
